<section>
    <div class="icc-card">
        <span class="icc-card__label" *ngIf="side === 'seller' && (document || documentList[0])?.salesDocumentTypeId !== 5">{{ 'SALES_DOCUMENT|Dokument sprzedaży:' | translate }}</span>
        <span class="icc-card__label" *ngIf="side === 'buyer' && (document || documentList[0])?.salesDocumentTypeId !== 5">{{ 'SALES_DOCUMENT|Dokument zakupu:' | translate }}</span>
        <span class="icc-card__label" *ngIf="(document || documentList[0])?.salesDocumentTypeId === 5">{{ 'SALES_DOCUMENT|Dokument:' | translate }}</span>

        <icc-select
            size="small"
            [value]="document?.uuid || ''"
            (valueChange)="changeActiveDocument($event)"
            name="document-select"
            *ngIf="documentList?.length > 1"
        >
            <option value=""><ng-container [ngSwitch]="documentList[0]?.salesDocumentTypeId">
                <ng-container *ngSwitchCase="1" >{{ 'SALES_DOCUMENT|Oferta' | translate }}</ng-container>
                <ng-container *ngSwitchCase="2" >{{ 'SALES_DOCUMENT|Zapytanie ofertowe' | translate }}</ng-container>
                <ng-container *ngSwitchCase="3" >{{ 'SALES_DOCUMENT|Zamówienie' | translate }}</ng-container>
                <ng-container *ngSwitchCase="5" >{{ 'SALES_DOCUMENT|Zamówienie serwisowe' | translate }}</ng-container>
            </ng-container> - {{'SALES_DOCUMENT|zbiorczo' | translate }}</option>

            <option *ngFor="let el of documentList; trackBy: trackByUuid" [value]="el.uuid"><ng-container [ngSwitch]="el?.salesDocumentTypeId">
                <ng-container *ngSwitchCase="1" >{{ 'SALES_DOCUMENT|Oferta' | translate }}</ng-container>
                <ng-container *ngSwitchCase="2" >{{ 'SALES_DOCUMENT|Zapytanie ofertowe' | translate }}</ng-container>
                <ng-container *ngSwitchCase="3" >{{ 'SALES_DOCUMENT|Zamówienie' | translate }}</ng-container>
                <ng-container *ngSwitchCase="5" >{{ 'SALES_DOCUMENT|Zamówienie serwisowe' | translate }}</ng-container>
            </ng-container> - {{ sellerCompany?.name }} - {{getDepartmentName(el.sellerProductDepartmentId)}}</option>

        </icc-select>

        <span class="icc-card__content__header" *ngIf="!documentList?.length && document || documentList?.length === 1">
            <ng-container [ngSwitch]="(document || documentList[0])?.salesDocumentTypeId">
                <ng-container *ngSwitchCase="1" >{{ 'SALES_DOCUMENT|Oferta' | translate }}</ng-container>
                <ng-container *ngSwitchCase="2" >{{ 'SALES_DOCUMENT|Zapytanie ofertowe' | translate }}</ng-container>
                <ng-container *ngSwitchCase="3" >{{ 'SALES_DOCUMENT|Zamówienie' | translate }}</ng-container>
                <ng-container *ngSwitchCase="5" >{{ 'SALES_DOCUMENT|Zamówienie serwisowe' | translate }}</ng-container>
            </ng-container>
            <span iccBadgeChip appearance='outline' >
                {{ document?.externalSource || ('SOURCE|ICC' | translate)}}
            </span>
        </span>

        <span class="flex-vertical width-100" *ngIf="document?.documentName || editDocumentName">

            <span class="icc-card__label width-100"> {{ 'SALES_DOCUMENT|Tytuł dokumentu:' | translate }} </span>

            <div
                *ngIf="document?.documentName && !editDocumentName"
                class="flex-horizontal width-100"
            >
                <div class="width-90 icc-card__content__header">
                    {{ document.documentName }}
                </div>
                <div class="width-10 right">
                    <button
                        iccIconButton
                        appearance="flat"
                        (click)="editDocumentName = true; focusInput('documentName')"
                        *ngIf="!document?.isConfirmed && !document?.isCanceled && document?.salesDocumentTypeId !== 2 && document?.salesDocumentTypeId !== 5"
                    >
                        <icc-icon name="edit"></icc-icon>
                    </button>
                </div>
            </div>
            <div
                *ngIf="editDocumentName"
                class="flex-horizontal width-100"
            >
                <div class="width-90">
                    <icc-input
                        [value]="document.documentName"
                        (valueChange)="changeTitle($event)"
                        name="document-name"
                        type="text"
                        #documentNameInput
                    ></icc-input>
                </div>
                <div class="width-10 right">
                    <button
                        iccIconButton
                        appearance="flat"
                        (click)="editDocumentName = false"
                    >
                        <icc-icon name="done"></icc-icon>
                    </button>
                </div>
            </div>
        </span>

        <span class="flex-vertical width-100" *ngIf="(document || documentList?.length === 1) && (document || documentList[0])?.salesDocumentTypeId !== 5">

            <span class="icc-card__label width-100"> {{ 'SALES_DOCUMENT|Własny kod oferty / zamówienia:' | translate }} </span>

            <div
                *ngIf="!editDocumentCode"
                class="flex-horizontal flex-horizontal--start width-100"
            >
                <div class="icc-card__content__header" *ngIf="(document || documentList[0]).documentCode">
                    {{ (document || documentList[0]).documentCode }}
                </div>
                <div class="right" *ngIf="(document || documentList[0])?.documentCode && side === 'seller' && hasAccessToEditCode">
                    <button
                        iccIconButton
                        appearance="flat"
                        (click)="editDocumentCode = true;focusInput('documentCode')"
                    >
                        <icc-icon name="edit"></icc-icon>
                    </button>
                </div>
                <button
                    *ngIf="!(document || documentList[0])?.documentCode && side === 'seller' && hasAccessToEditCode"
                    iccButton
                    appearance="outline"
                    (click)="editDocumentCode = true;focusInput('documentCode')"
                >
                    {{ 'SALES_DOCUMENT|Własny kod' | translate }}
                    <icc-icon name="add"></icc-icon>
                </button>
            </div>
            <div
                *ngIf="editDocumentCode"
                class="flex-horizontal width-100"
            >
                <div class="width-90">
                    <icc-input
                        [value]="(document || documentList[0]).documentCode"
                        (valueChange)="changeDocumentCode($event)"
                        name="document-name"
                        type="text"
                        [maxLength]="30"
                        [inputLengthIsVisible]="true"
                        #documentCodeInput
                    ></icc-input>
                </div>
                <div class="width-10">
                    <button
                        iccIconButton
                        appearance="flat"
                        (click)="editDocumentCode = false"
                    >
                        <icc-icon name="done"></icc-icon>
                    </button>
                </div>
            </div>

        </span>
    </div>
    <div class="document-card_number_dates">
        <div class="icc-card document-card__number">
            <span class="icc-card__label">{{ 'SALES_DOCUMENT|Numer dokumentu:' | translate }}</span>
            <span class="icc-card__content__header">
                <icc-document-detail [document]="document" [documentList]="documentList" property="documentNumber" [transform]="joinNumber">
                    <ng-template iccDocumentDetailContent let-value="value">
                        {{ value }}
                    </ng-template>
                </icc-document-detail>

                <span
                    class="document-card_number__detail__edit"
                    *ngIf="customCode && !document?.isConfirmed && !document?.isCanceled && side === 'seller' && (document || documentList[0])?.salesDocumentTypeId !== 5"
                >

                    <button
                        *ngIf="!documentCodeEditing && customCode && side === 'seller'"
                        iccButton
                        appearance="outline"
                        (click)="documentCodeEditing = true; documentCodeEditingBlock = true; inputCustomCode && inputCustomCode.focus()"

                    >
                        {{ 'SALES_DOCUMENT|Referencja' | translate }}
                        <icc-icon name="add"></icc-icon>
                    </button>

                    <icc-input
                        *ngIf="documentCodeEditing && customCode && side === 'seller'"
                        size="small"
                        type="text"
                        [value]="document?.documentCustomCode"
                        name="custom-code"
                        (valueChange)="changeCustomCode($event);documentCodeEditing = false; documentCodeEditingBlock = false"
                        [disabled]="document?.externalSource === 'ERP'"
                        (click)="documentCodeEditing = true; documentCodeEditingBlock = true"
                        #inputCustomCode
                    ></icc-input>

                    <button
                        *ngIf="documentCodeEditing && customCode && side === 'seller'"
                        iccIconButton
                        appearance="flat"
                        (click)="documentCodeEditing = false; documentCodeEditingBlock = false"
                    >
                        <icc-icon name="done"></icc-icon>
                    </button>

                </span>
            </span>
        </div>
        <div class="icc-card document-card__requested-date" *ngIf="(document || documentList.length && documentList[0]) && (hasAccessToEditRequestedDeadline || (document || documentList[0])?.requestedDeadline && side === 'seller')">
            <span class="icc-card__label">
                {{ 'SALES_DOCUMENT|Oczekiwana data na inwestycji:' | translate }}
                <button
                    iccIconButton
                    appearance="flat"
                   [title]="'SALES_DOCUMENT|Data do wyłącznego użytku firmy i nie jest brana pod uwagę przez dostawcę' | translate"
                >
                    <icc-icon name="info"></icc-icon>
                </button>
            </span>
            <div
                *ngIf="!editRequestedDeadline"
            >
                <button
                    *ngIf="!(document || documentList[0])?.requestedDeadline && side === 'seller' && hasAccessToEditRequestedDeadline"
                    iccButton
                    appearance="outline"
                    (click)="editRequestedDeadline = true;focusInput('requestedDeadline')"
                >
                    {{ 'SALES_DOCUMENT|Oczekiwana data na inwestycji' | translate }}
                    <icc-icon name="add"></icc-icon>
                </button>
                <span class="icc-card__content__header">
                    <ng-container *ngIf="document; else minRequestedDate">
                        {{ document.requestedDeadline | date : 'shortDate' }}
                    </ng-container>
                    <ng-template #minRequestedDate>
                        <ng-container *ngIf="documentList.length > 1">
                            {{ 'SALES_DOCUMENT|minimum {date}' | translate: {date: (getOldest('requestedDeadline') | date : 'shortDate') } }}
                        </ng-container>
                        <ng-container *ngIf="documentList.length === 1">
                            {{ getOldest('requestedDeadline') | date : 'shortDate' }}
                        </ng-container>
                    </ng-template>
                </span>
                <div class="right" *ngIf="(document || documentList[0])?.requestedDeadline && side === 'seller' && hasAccessToEditRequestedDeadline">
                    <button
                        iccIconButton
                        appearance="flat"
                        (click)="editRequestedDeadline = true;focusInput('requestedDeadline')"
                    >
                        <icc-icon name="edit"></icc-icon>
                    </button>
                </div>
            </div>
            <div
                *ngIf="editRequestedDeadline"
            >
                <icc-input
                    [value]="(document || documentList[0])?.requestedDeadline"
                    (valueChange)="changeRequestedDeadline($event)"
                    name="requested-deadline"
                    type="date"
                    #requestedDeadlineInput
                    [calendarPopover]="true"
                ></icc-input>
                <button
                    iccIconButton
                    appearance="flat"
                    (click)="editRequestedDeadline = false"
                >
                    <icc-icon name="done"></icc-icon>
                </button>
            </div>

        </div>
        <div class="icc-card document-card__dates">
            <ng-container
                *ngIf="(document || documentList.length && documentList[0])?.validityDate && showValidityInfo"
            >
                <span class="icc-card__label"  *ngIf="(document || documentList[0])?.salesDocumentTypeId === 1">
                    {{ 'SALES_DOCUMENT|Termin ważności oferty:' | translate }}
                </span>
                <span class="icc-card__label"  *ngIf="(document || documentList[0])?.salesDocumentTypeId === 2">
                    {{ 'SALES_DOCUMENT|Termin ważności zapytania ofertowego:' | translate }}
                </span>
                <span class="icc-card__label"  *ngIf="(document || documentList[0])?.salesDocumentTypeId === 3">
                    {{ 'SALES_DOCUMENT|Termin ważności zamówienia:' | translate }}
                </span>
            </ng-container>
            <ng-container
                *ngIf="showDeadlineInfo"
            >
                <span class="icc-card__label"  *ngIf="!hasDeclaredDeadline && (document || documentList[0])?.salesDocumentTypeId !== 5">
                    {{ 'SALES_DOCUMENT|Szacowany termin realizacji:' | translate }}
                </span>
                <span class="icc-card__label"  *ngIf="hasDeclaredDeadline">
                    {{ 'SALES_DOCUMENT|Deklarowany termin realizacji:' | translate }}
                </span>
            </ng-container>
            <span class="icc-card__content__header">
                <ng-container
                    *ngIf="(document || documentList.length && documentList[0])?.validityDate && showValidityInfo"
                >
                    <ng-container *ngIf="document; else minValidDate">
                        {{ visibleValidDate | date : 'shortDate' }}
                    </ng-container>
                    <ng-template #minValidDate>
                        <ng-container *ngIf="documentList.length > 1">
                            {{ 'SALES_DOCUMENT|minimum {date}' | translate: {date: (visibleValidDate | date : 'shortDate') } }}
                        </ng-container>
                        <ng-container *ngIf="documentList.length === 1">
                            {{ visibleValidDate | date : 'shortDate' }}
                        </ng-container>
                    </ng-template>
                </ng-container>
                <ng-container *ngIf="showDeadlineInfo">
                    <ng-container *ngIf="!hasDeclaredDeadline; else declaredDeadline">
                        {{ estimatedDeadlineText }}
                    </ng-container>
                    <ng-template #declaredDeadline>
                        <ng-container *ngIf="document; else minDeadline">
                            {{ document?.declaredDeadline | date : 'shortDate' }}
                        </ng-container>
                    </ng-template>
                    <ng-template #minDeadline>
                        {{ getLatest('declaredDeadline') | date : 'shortDate' }}
                    </ng-template>
                </ng-container>
            </span>
            <span class="icc-card__content__info" *ngIf="showDeadlineInfo && !hasDeclaredDeadline && estimatedDeadlineInfo && (document || documentList[0])?.salesDocumentTypeId !== 5" [innerHTML]="estimatedDeadlineInfo"></span>
        </div>
    </div>
    <div class="document-card_status" *ngIf="showStatus">
        <span class="document-card_status__label">
            {{ 'SALES_DOCUMENT|Status:' | translate }}
            <button
                iccIconButton
                appearance="flat"
                (click)="showStatusInfo()"
                *ngIf="isStatusInfoVisible"
            >
                <icc-icon name="info"></icc-icon>
            </button>
        </span>
        <span class="document-card_status__detail">

            <icc-document-detail [document]="document" [documentList]="documentList" property="statusId">
                <ng-template iccDocumentDetailContent let-value="value">
                    <icc-document-status *ngIf="!canChangeStatus" [status]="documentStatusMap[value]"></icc-document-status>
                    <icc-form-field
                        size="small"
                        *ngIf="canChangeStatus"
                    >
                        <icc-icon name="state"  [ngStyle]="{'color': '#'+statusColorHex}" ></icc-icon>
                        <icc-select
                            size="small"
                            [value]="value"
                            (valueChange)="changeStatus($event)"
                            name="document-status"
                            >
                            <option *ngFor="let el of documentStatuses" [value]="el.id" >
                                {{ el.name }}
                            </option>
                        </icc-select>
                    </icc-form-field>
                </ng-template>
            </icc-document-detail>

        </span>
    </div>

    <div class="document-card" *ngIf="showFlags">
        <span class="document-card__label">
            {{ 'SALES_DOCUMENT|Flagi:' | translate }}
        </span>
        <span class="document-card__content">
            <div class="flex-vertical flags" *ngIf="singleBuyFlags; else diffInfo">
                <icc-document-flags *ngIf="document || documentList?.length" [document]="document || documentList[0]" [group]="1" [statusSystem]="statusSystem" [side]="side" [hasInactiveProducts]="hasInactiveProducts" (change)="changeFlag($event)"></icc-document-flags>
                <icc-document-flags *ngIf="document || documentList?.length" [document]="document || documentList[0]" [group]="2" [statusSystem]="statusSystem" [side]="side" [hasInactiveProducts]="hasInactiveProducts" (change)="changeFlag($event)"></icc-document-flags>
            </div>
            <ng-template #diffInfo>
                <p class="detail-diff">{{ 'INTERFACE|różne wartości' | translate}}</p>
            </ng-template>
        </span>
    </div>


    <button
        iccIconButton
        appearance="flat"
        [iccMenuTriggerFor]="documentOptionsMenu"
        class="document-card-options-button"
        *ngIf="side === 'seller' && document.salesDocumentTypeId !== 2 && (document || documentList[0])?.salesDocumentTypeId !== 5 && !document?.isConfirmed && !document?.isCanceled"
    >
        <icc-icon name="more_vertical"></icc-icon>
    </button>

</section>

<section *ngIf="side === 'seller' && hasAccessToSendQuotationEmailToClient">
    <span class="icc-card__label">{{ 'SALES_DOCUMENT|Wysłano klientowi:' | translate }}</span>
    <span class="icc-card__content__header">
        {{(document || documentList[0])?.isSentToBuyer ? ('INTERFACE|Tak' | translate) : ('INTERFACE|Nie' | translate)}}
    </span>
</section>

<section *ngIf="side === 'seller' && (document || documentList[0])?.salesDocumentTypeId !== 5">

    <div class="flex-horizontal">

        <div class="document-card discount">
            <span class="document-card__label">
                {{ 'SALES_DOCUMENT|Rabat dodatkowy:' | translate }}
            </span>
            <span class="document-card__content" >

                <icc-input
                    type="number"
                    [step]="0.01"
                    [(ngModel)]="additionalDiscount"
                    (valueChange)="changeAdditionalDiscount($event)"
                    name="discount"
                    [disabled]="document?.isConfirmed || document?.isCanceled || document.salesDocumentTypeId === 2"
                    align="right"
                    suffix="%"
                    size="small"
                    inputmode="decimal"
                ></icc-input>

            </span>
        </div>
    </div>
</section>
<section>
    <div class="flex-horizontal wrap-conditional">

        <div class="document-card_data" *ngIf="seller || sellerCompany">
            <span class="document-card_data__label" *ngIf="(document || documentList[0])?.salesDocumentTypeId !== 5">
                {{ 'SALES_DOCUMENT|Sprzedający:' | translate }}
            </span>
            <span class="document-card_data__label" *ngIf="(document || documentList[0])?.salesDocumentTypeId === 5">
                {{ 'SALES_DOCUMENT|Dostawca:' | translate }}
            </span>
            <div class="document-card_data__content">
                <div class="document-card_data__content-box">

                    <icc-document-detail [document]="document" [documentList]="documentList" property="sellerUserId">
                        <ng-template iccDocumentDetailContent let-value="value">
                            <b class="document-card_data__content-box__company_name">{{ seller?.companyName }}</b><br>
                            <b class="document-card_data__content-box__name">{{ seller?.reference }}</b><br>
                            <span *ngIf="seller?.phoneNumber || seller?.registryPhone">{{ 'CONTACT|tel.' | translate }} {{ seller?.phoneNumber || seller?.registryPhone }}<br></span>
                            {{ seller?.email || seller?.registryEmail }}<br>

                            <div class="document-card_data__content-box__actions">
                                <button iccIconButton appearance="flat" (click)="openSellerDialog()" [title]="'INTERFACE|Zmień' | translate"
                                    *ngIf="canChangeSeller() && !document?.isConfirmed && !document?.isCanceled && side === 'seller' && document.salesDocumentTypeId !== 2 && document.salesDocumentTypeId !== 5"
                                >
                                    <icc-icon name="edit"></icc-icon>
                                </button>
                                <button iccIconButton appearance="flat" (click)="openClientPreviewDialog(true)" [title]="'INTERFACE|Szczegóły' | translate" *ngIf="(document || documentList[0])?.salesDocumentTypeId !== 5">
                                    <icc-icon name="open"></icc-icon>
                                </button>
                            </div>

                        </ng-template>
                    </icc-document-detail>

                </div>
            </div>
        </div>
        <div class="document-card_data">
            <span class="document-card_data__label">
                {{ 'SALES_DOCUMENT|Dokument przygotowany przez:' | translate }}
            </span>
            <div class="document-card_data__content">
                <div class="document-card_data__content-box">
                    <icc-document-detail [document]="document" [documentList]="documentList" property="authorUserId">

                        <ng-template iccDocumentDetailContent let-value="value">

                            <b class="document-card_data__content-box__name" >{{ author?.referenceName }}</b><br>
                            <span *ngIf="author?.phoneNumber">{{ 'CONTACT|tel.' | translate }} {{ author?.phoneNumber }}<br></span>
                            {{ author?.email }}<br>
                            <span class="document-card_data__content-box__date">
                                {{ 'SALES_DOCUMENT|data:' | translate }}
                                <ng-container *ngIf="document; else minCreated">
                                    {{ document?.created | date : 'shortDate' }}
                                </ng-container>
                                <ng-template #minCreated>
                                    <ng-container *ngIf="documentList.length > 1">
                                        {{ 'SALES_DOCUMENT|minimum {date}' | translate: {date: (getOldest('created') | date : 'shortDate')} }}
                                    </ng-container>
                                    <ng-container *ngIf="documentList.length === 1">
                                        {{ getOldest('created') | date : 'shortDate' }}
                                    </ng-container>
                                </ng-template>
                            </span>
                            <span class="document-card_data__content-box__date">
                                {{ 'SALES_DOCUMENT|data ost. edycji:' | translate }}
                                <ng-container *ngIf="document; else lastModified">
                                    {{ document?.modified | date : 'shortDate' }}
                                </ng-container>
                                <ng-template #lastModified>
                                    {{ getLatest('modified') | date : 'shortDate' }}
                                </ng-template>
                            </span>

                            <div class="document-card_data__content-box__actions">
                                <button iccIconButton appearance="flat" (click)="openDocumentHistoryDialog()" [title]="'SALES_DOCUMENT|Historia zmian' | translate">
                                    <icc-icon name="history"></icc-icon>
                                </button>
                            </div>

                        </ng-template>

                    </icc-document-detail>
                </div>
            </div>
        </div>
    </div>
    <div class="flex-horizontal wrap-conditional">

        <div class="document-card_data">
            <span class="document-card_data__label" *ngIf="(document || documentList[0])?.salesDocumentTypeId !== 5">
                {{ 'SALES_DOCUMENT|Kupujący:' | translate }}
            </span>
            <span class="document-card_data__label" *ngIf="(document || documentList[0])?.salesDocumentTypeId === 5">
                {{ 'SALES_DOCUMENT|Zamawiający:' | translate }}
            </span>
            <div class="document-card_data__content">
                <div class="document-card_data__content-box">

                    <ng-container
                        *ngIf="side === 'seller' && isEmpty(document?.client) && canEditClient  && !document?.isConfirmed && !document?.isCanceled && (document?.salesDocumentTypeId === 1 || document?.salesDocumentTypeId === 5)"
                    >

                        <button
                            iccButton
                            appearance="outline"
                            (click)="openClientDialog(true)"
                        >
                            {{ 'INTERFACE|Z listy' | translate }}
                            <icc-icon name="search"></icc-icon>
                        </button>

                        <button
                            iccButton
                            appearance="outline"
                            (click)="openClientDialog(false)"
                            *ngIf="document?.salesDocumentTypeId !== 5"
                        >
                            {{ 'INTERFACE|Wprowadź' | translate }}
                            <icc-icon name="edit"></icc-icon>
                        </button>

                    </ng-container>

                    <icc-document-detail [document]="document" [documentList]="documentList" property="client">

                        <ng-template iccDocumentDetailContent let-client="value">
                            <span class="document-card_data__content-box__wrapper" *ngIf="client">
                                <b class="document-card_data__content-box__company_name" *ngIf="client?.companyName">{{ client?.companyName }}<br></b>
                                <b class="document-card_data__content-box__name" *ngIf="!client?.isCompany">{{ client?.firstName }} {{ client?.lastName }}<br></b>
                                <span *ngIf="client?.isCompany">{{ client?.firstName }} {{ client?.lastName }}<br></span>
                                <span *ngIf="client?.phoneNumber || client?.registryPhone">{{ 'CONTACT|tel.' | translate }} {{ client?.phoneNumber || client?.registryPhone }}<br></span>
                                {{ client?.email || client?.registryEmail }}<br>
                            </span>
                        </ng-template>

                    </icc-document-detail>

                    <div class="document-card_data__content-box__actions">

                        <button iccIconButton appearance="flat" (click)="openClientDialog()"
                            *ngIf="!salesDocument && canEditClient && !isEmpty((document || documentList && documentList[0])?.client)"
                            [title]="'INTERFACE|Zmień' | translate"
                        >
                            <icc-icon name="edit"></icc-icon>
                        </button>
                        <button iccIconButton appearance="flat" (click)="openSellerDialog()"
                            *ngIf="salesDocument && canEditClient && canEditSeller"
                            [title]="'INTERFACE|Zmień' | translate"
                        >
                            <icc-icon name="edit"></icc-icon>
                        </button>
                        <button iccIconButton appearance="flat" (click)="openClientPreviewDialog()"
                            *ngIf="!isEmpty((document || documentList && documentList[0])?.client) && (document || documentList[0])?.salesDocumentTypeId !== 5"
                            [title]="'INTERFACE|Podgląd' | translate"
                        >
                            <icc-icon name="open"></icc-icon>
                        </button>

                    </div>

                </div>
            </div>
        </div>
    </div>
</section>
<section class="document-card-details">

    <div class="document-card" *ngIf="(document || documentList.length && documentList[0])?.externalId">
        <span class="document-card__label" translate>SALES_DOCUMENT|Numer zamówienia z zewnętrznego systemu:</span>
        <span class="document-card__content">
            <icc-document-detail [document]="document" [documentList]="documentList" property="externalId">
                <ng-template iccDocumentDetailContent let-value="value">
                    {{ value }}
                </ng-template>
            </icc-document-detail>
        </span>
    </div>

    <div class="document-card" *ngIf="(document || documentList.length && documentList[0])?.externalIds && !isEmpty((document || documentList.length && documentList[0])?.externalIds)">
        <span class="document-card__label" translate>SALES_DOCUMENT|Powiązane dokumenty z zewnętrznych systemów:</span>
        <span class="document-card__content">
            <icc-document-detail [document]="document" [documentList]="documentList" property="externalIds">
                <ng-template iccDocumentDetailContent let-value="value">
                    <ng-container *ngFor="let el of value | keyvalue">
                        <span>{{ el.key }}: {{ el.value }}</span><br>
                    </ng-container>
                </ng-template>
            </icc-document-detail>
        </span>
    </div>

    <div class="document-card" *ngIf="(document || documentList.length && documentList[0])?.isOrderPlaced">
        <span class="document-card__label" translate>SALES_DOCUMENT|Data przekazania zamówienia:</span>
        <span class="document-card__content">
            <ng-container *ngIf="document; else lastModified">
                {{ document?.modified | date : 'shortDate' }}
            </ng-container>
            <ng-template #lastModified>
                {{ getLatest('modified') | date : 'shortDate' }}
            </ng-template>
        </span>
    </div>

    <p class="document-card__content__warning" *ngIf="showOfferValidityWarning && (document || documentList[0])?.salesDocumentTypeId === 1" translate>SALES_DOCUMENT|Kończy się termin ważności oferty</p>
    <div class="document-card__content__error" *ngIf="invalidOffer  && (document || documentList[0])?.salesDocumentTypeId === 1">
        <p>{{ 'SALES_DOCUMENT|Minął termin ważności oferty. Należy przeliczyć ceny w ofercie.' | translate }}</p><br *ngIf="canIgnorePriceVersionValidity">
        <button iccButton appearance="outline" *ngIf="canIgnorePriceVersionValidity" (click)="ignorePriceVersionValidity()">{{ 'SALES_DOCUMENT|Zezwól na edycję dokumentu' | translate }}</button>
    </div>
    <p class="document-card__content__warning" *ngIf="showOfferValidityWarning && (document || documentList[0])?.salesDocumentTypeId === 2" translate>SALES_DOCUMENT|Kończy się termin ważności zapytania ofertowego</p>
    <p class="document-card__content__error" *ngIf="invalidOffer  && (document || documentList[0])?.salesDocumentTypeId === 2" translate>SALES_DOCUMENT|Minął termin ważności zapytania ofertowego. Należy przeliczyć ceny w zapytaniu ofertowym.</p>
    <p class="icc-card__content__warning" *ngIf="showOfferValidityWarning && (document || documentList[0])?.salesDocumentTypeId === 3" translate>SALES_DOCUMENT|Kończy się termin ważności zamówienia</p>
    <p class="icc-card__content__error" *ngIf="invalidOffer && (document || documentList[0])?.salesDocumentTypeId === 3" translate>SALES_DOCUMENT|Minął termin ważności zamówienia.</p>

    <div class="document-card"
        *ngIf="!(document || documentList.length && documentList[0])?.validityDate && !showValidityInfo && invalidOffer"
    >
        <span class="document-card__label" translate>PRICE_VERSION|Nieaktualna wersja cenowa:</span>
        <p class="document-card__content__error" *ngIf="(document || documentList[0])?.salesDocumentTypeId === 1" translate>SALES_DOCUMENT|Wersja cenowa w tej ofercie jest nieaktualna.</p>
        <p class="document-card__content__error" *ngIf="(document || documentList[0])?.salesDocumentTypeId === 2" translate>SALES_DOCUMENT|Wersja cenowa w tym zapytaniu ofertowym jest nieaktualna.</p>
        <p class="document-card__content__error" *ngIf="(document || documentList[0])?.salesDocumentTypeId === 3" translate>SALES_DOCUMENT|Wersja cenowa w tym zamówieniu jest nieaktualna.</p>
    </div>

</section>


<icc-menu #documentOptionsMenu="iccMenu" xPosition="before" yPosition="below" class="document-cards-options-menu">
    <button
        *ngIf="!document?.documentName && !editDocumentName && !document?.isConfirmed && !document?.isCanceled && document?.salesDocumentTypeId !== 2"
        icc-menu-item
        (click)="editDocumentName=true; focusInput('documentName')"
    >
        <icc-icon name="add"></icc-icon>
        <span>{{ 'SALES_DOCUMENT|Dodaj tytuł' | translate }}</span>
    </button>

    <button
        *ngIf="(document?.documentName || editDocumentName) && !document?.isConfirmed && !document?.isCanceled && document?.salesDocumentTypeId !== 2"
        icc-menu-item
        (click)="clearDocumentName(document)"
    >
        <icc-icon name="remove"></icc-icon>
        <span>{{ 'SALES_DOCUMENT|Usuń tytuł' | translate }}</span>
    </button>
    <button icc-menu-item (click)="openTaxDialog()" *ngIf="!document?.isConfirmed && !document?.isCanceled">
        <icc-icon name="settings"></icc-icon>
        <span>{{ 'SALES_DOCUMENT|Ustawienia VAT' | translate }}</span>
    </button>
</icc-menu>